import type React from "react";
import { useSelector } from "react-redux";
import Button from "~/components/ui/button";
import PlanListItem from "~/components/ui/planListItem";
import { planMap } from "~/constants/planMap";
import type { RootState } from "~/store";
import styles from "./index.module.scss";

type PricingCardProps = {
  title: string;
  subtitle: string;
  price: string;
  features: string[];
  recommended?: boolean;
  selected?: boolean;
  onClick?: () => void;
  period?: string;
  isCurrentPlan?: boolean;
};

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  subtitle,
  price,
  features,
  recommended = false,
  selected = false,
  onClick,
  period = "年",
  isCurrentPlan: isCurrentPlanProp,
}) => {
  const { organization } = useSelector((state: RootState) => state.auth);
  const orgPlanLabel = organization?.plan?.type ? planMap[organization.plan.type]?.name || "" : "";
  const isCurrentPlan = isCurrentPlanProp ?? (orgPlanLabel ? orgPlanLabel.includes(title) : false);
  const isDisabled = isCurrentPlan;

  const cardClasses = [
    styles["card"],
    selected ? styles["recommended"] : "",
    isCurrentPlan ? styles["currentPlan"] : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cardClasses} onClick={!isDisabled ? onClick : undefined}>
      <div className={styles["badgeRow"]}>
        {isCurrentPlan && <div className={styles["currentBadge"]}>現在のプラン</div>}
        <div className={`${styles["badge"]} ${!recommended ? styles["hidden"] : ""}`}>おすすめ</div>
      </div>
      <h3 className={styles["title"]}>{title}</h3>
      <p className={styles["subtitle"]}>{subtitle}</p>
      <div className={styles["priceBlock"]}>
        <span className={styles["priceYen"]}>¥</span>
        <span className={styles["price"]}>{price}</span>
        <span className={styles["pricePeriod"]}>/{period}（税抜）</span>
      </div>
      <Button
        label={isCurrentPlan ? "ご利用中" : "プランを変更する"}
        {...(!isDisabled && onClick && { onClick })}
        styleType={isCurrentPlan ? "current-plan" : "blue-selected-plan"}
        disabled={isDisabled}
      />
      <div className={styles["selectedList"]}>
        {features.map((feature, i) => (
          <PlanListItem key={i} text={feature} />
        ))}
      </div>
    </div>
  );
};

export default PricingCard;
